module.exports = __webpack_public_path__ + "img/pro-smt.26cdcfe8.png";